import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import FullForm from '../Layouts/FullForm';
import './documentation-upload.scss';

const formActions = require('react-redux-form').actions;
import { formatText, HtmlText } from 'core/i18n';

const documentationActions = require('actions/documentationActions');
const preLoaderActions = require('actions/preLoaderActions');

import { ProfileStep5 } from '../../components/newAccountSteps/profileSteps/ProfileStep5/ProfileStep5Container';
import DocumentRetryRequestModal from 'components/DocumentRetryRequestModal';
import { useModal } from '../../hooks/useModal';

const DocumentationUpload = ({
    preLoaderActions,
    documentationActions,
    userProfile: { accessToken, documentationStatusCounter },
}) => {
    const { isOpen, toggleModal } = useModal({ isInitialOpen: Boolean(documentationStatusCounter) });

    useEffect(() => {
        documentationActions.getInformationDocument(accessToken, () => {
            preLoaderActions.hidePreLoader();
        });
    }, []);

    return (
        <FullForm
            title={HtmlText(formatText('stepsTitles-documentation'))}
            subtitle={HtmlText(formatText('contentStepsTitles-attachImages'))}
            continueAction={() => {}}
            formModel="userProfile"
            onSubmit={() => {}}
            icon="documentos"
            hideRoadmapNavigation
        >
            <ProfileStep5 isAres />
            <DocumentRetryRequestModal onClose={toggleModal} modalIsOpen={isOpen} />
        </FullForm>
    );
};

export default connect(
    state => ({
        userProfile: state.userProfile,
        options: state.options,
        userProfileForm: state.userProfileForm,
    }),
    dispatch => ({
        formActions: bindActionCreators(formActions, dispatch),
        documentationActions: bindActionCreators(documentationActions, dispatch),
        preLoaderActions: bindActionCreators(preLoaderActions, dispatch),
    })
)(DocumentationUpload);
